/**
 * Generates a filesystem-safe filename with timestamp for downloads
 * @returns A filename string in the format: livestream_YYYY-MM-DDThh-mm-ss-mmmZ.mp4
 */
export const generateDownloadFilename = (prefix: string): string => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `${prefix}_${timestamp}.mp4`;
};
